import { css } from "@filadd/phi-plus-styled-system/css";
export const notificationListStyle = css({
    height: 56,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    ml: -2,
    mr: -4,
    pr: 2,
});
//# sourceMappingURL=notificationListStyle.js.map